const muiInputBase = (theme) => {
  return {
    MuiInputBase: {
      defaultProps: {},
      styleOverrides: {},
    },
  };
};

export default muiInputBase;
